import { render, staticRenderFns } from "./mvs.vue?vue&type=template&id=2946f3cc&scoped=true&"
import script from "./mvs.vue?vue&type=script&lang=js&"
export * from "./mvs.vue?vue&type=script&lang=js&"
import style0 from "./mvs.vue?vue&type=style&index=0&id=2946f3cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946f3cc",
  null
  
)

export default component.exports